import { v4 as uuid } from 'uuid';

import { Reservation } from '@luxuryescapes/contract-svc-reservation';

export interface Schedule {
  id?: string;
  activePeriod: {
    from: string;
    to: string;
  };
  travelPeriod: {
    from: string;
    to: string;
  };
  type: 'tactical' | 'sell';
  parent?: string;
}

export const prepareSchedulesList = (schedules_list: Schedule, parentId?: string) => {
  if (!schedules_list) {
    return [];
  }

  return Object.values(schedules_list)
    .filter(
      (schedule) =>
        schedule.activePeriod.from &&
        schedule.activePeriod.to &&
        schedule.travelPeriod.from &&
        schedule.travelPeriod.to &&
        schedule.type,
    )
    .map((schedule) => ({
      id: schedule.id || undefined, // ensure empty strings are not passed
      parent: schedule.parent || parentId || undefined,
      type: schedule.type,
      activePeriod: {
        from: schedule.activePeriod.from,
        to: schedule.activePeriod.to,
      },
      travelPeriod: {
        from: schedule.travelPeriod.from,
        to: schedule.travelPeriod.to,
      },
    }));
};

export const ingestSchedules = (schedules_list: Array<Reservation.Schedule>): any => {
  if (!schedules_list) {
    return {};
  }

  const output: Record<string, Schedule> = {};
  [...schedules_list]
    .sort(
      (a: Schedule, b: Schedule) => new Date(a.activePeriod.from).getTime() - new Date(b.activePeriod.from).getTime(),
    )
    .forEach((s: Schedule) => {
      output[uuid()] = s;
    });
  return output;
};
